import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CUSTOM_EVENT_SESSION_LOGOUT } from '@/state/session';
import { ScreenRoutes } from '@/types/router';

/**
 * Sends the user back to sign-in when the API answers 401 outside sign-in (the API instance fires
 * `CUSTOM_EVENT_SESSION_LOGOUT`). Mounted by the protected routes only, so a 401 on a public page
 * (an expired session checked by `useMe`) does not bounce the visitor around.
 */
export const useSessionLogoutRedirect = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleLogout = () => {
      queryClient.clear();
      navigate(ScreenRoutes.SIGNIN, { replace: true });
    };

    document.addEventListener(CUSTOM_EVENT_SESSION_LOGOUT, handleLogout);
    return () => document.removeEventListener(CUSTOM_EVENT_SESSION_LOGOUT, handleLogout);
  }, [navigate, queryClient]);
};
